var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "" + _vm.title + (_vm.isSingleCheck ? "（单选）" : ""),
        visible: _vm.dialogVisible,
        "append-to-body": _vm.isAppendToBody,
        width: "60%",
        modal: false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.cancel,
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.generalLoading,
              expression: "generalLoading",
            },
          ],
          staticClass: "content",
        },
        [
          _c("div", { staticClass: "left" }, [
            _c(
              "div",
              { staticClass: "search-bar" },
              [
                _c("el-input", {
                  staticClass: "search-input",
                  attrs: {
                    "prefix-icon": "el-icon-search",
                    placeholder: "输入关键字搜索",
                    size: "mini",
                    clearable: "",
                  },
                  on: { clear: _vm.resetList },
                  model: {
                    value: _vm.searchValue,
                    callback: function ($$v) {
                      _vm.searchValue = $$v
                    },
                    expression: "searchValue",
                  },
                }),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "search-button",
                    attrs: { type: "text", size: "small" },
                    on: { click: _vm.searchList },
                  },
                  [_vm._v("搜索")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "search-button",
                    attrs: { type: "text", size: "small" },
                    on: { click: _vm.resetList },
                  },
                  [_vm._v("重置")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "breadcrumbs" },
              [
                _c("i", { staticClass: "el-icon-office-building" }),
                _vm._v(" "),
                _vm.crumbList.length
                  ? _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "dark",
                          content: _vm.crumbList
                            .map(function (e) {
                              return e.label
                            })
                            .join(" > "),
                          placement: "top",
                        },
                      },
                      [
                        _c("div", { staticClass: "crumb-str text-ellipsis" }, [
                          _vm._v(
                            _vm._s(
                              _vm.crumbList
                                .map(function (e) {
                                  return e.label
                                })
                                .join(" > ")
                            )
                          ),
                        ]),
                      ]
                    )
                  : _c("div", { staticClass: "crumb-str text-ellipsis" }, [
                      _vm._v("请从列表中选择数据"),
                    ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.listLoading,
                    expression: "listLoading",
                  },
                ],
                staticClass: "list",
              },
              [
                _c(
                  "div",
                  { staticClass: "check-all" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: {
                          indeterminate: _vm.indeterminateAll,
                          disabled: _vm.isSingleCheck,
                        },
                        on: { change: _vm.checkedAllChange },
                        model: {
                          value: _vm.currentCheckedAll,
                          callback: function ($$v) {
                            _vm.currentCheckedAll = $$v
                          },
                          expression: "currentCheckedAll",
                        },
                      },
                      [_vm._v("全选")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "20px" },
                        style: {
                          marginLeft: "20px",
                          visibility:
                            _vm.crumbList.length > 1 ||
                            (_vm.crumbList.length &&
                              _vm.crumbList[0].code !== _vm.rootDeptCode)
                              ? "visible"
                              : "hidden",
                        },
                        attrs: { type: "text" },
                        on: { click: _vm.prevLevel },
                      },
                      [_vm._v("上一级")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.list, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      ref: "listItem" + index,
                      refInFor: true,
                      staticClass: "list-item",
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          class: [
                            item.disabledColorNormal && "user-dept-checkbox",
                          ],
                          attrs: {
                            indeterminate: item.indeterminate,
                            disabled: item.disabled,
                          },
                          on: {
                            change: function () {
                              return _vm.checkedChange(item, false)
                            },
                          },
                          model: {
                            value: item.checked,
                            callback: function ($$v) {
                              _vm.$set(item, "checked", $$v)
                            },
                            expression: "item.checked",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              ref: "listItemCheckLabel" + index,
                              refInFor: true,
                              staticClass: "checkbox-label",
                            },
                            [
                              _c("i", {
                                class: item.icon,
                                staticStyle: { "margin-right": "5px" },
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(item.label))]),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          style: {
                            marginLeft: "20px",
                            visibility: !item.leaf ? "visible" : "hidden",
                          },
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.nextLevel(item)
                            },
                          },
                        },
                        [_vm._v("下一级")]
                      ),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "right" }, [
            _c("div", { staticClass: "total-bar" }, [
              _c("span", [
                _vm._v("已选 " + _vm._s(_vm.checkedList.length) + " 项"),
              ]),
              _vm._v(" "),
              _c("span", { on: { click: _vm.clearAllChecked } }, [
                _vm._v("清空"),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.checkedListLoading,
                    expression: "checkedListLoading",
                  },
                ],
                staticClass: "checked-list",
              },
              [
                _vm.checkedList.length
                  ? _vm._l(_vm.checkedList, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "checked-list-item" },
                        [
                          _c("span", [_vm._v(_vm._s(item.showCheckedName))]),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "el-icon-close",
                            on: {
                              click: function ($event) {
                                return _vm.deleteThisChecked(item)
                              },
                            },
                          }),
                        ]
                      )
                    })
                  : _c(
                      "div",
                      { staticClass: "empty-box" },
                      [
                        _c("el-empty", {
                          attrs: { description: "请点击左侧列表选择数据" },
                        }),
                      ],
                      1
                    ),
              ],
              2
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.cancel } },
            [_vm._v("取 消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.submit },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }